import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { Content, ButtonActions, CloseIcon } from './Theme'
import { ReactComponent as Close } from 'assets/icons/CloseFilter.svg';
import { Fonts, FontColors } from "theme/fontConfig";

export default function NewDialog({ isOpen, handleClose, title, sx, children, content, contentStyle, buttonStyle }) {


    return (
        <Dialog
            open={isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            onClose={handleClose}
            sx={sx}
        >
            <CloseIcon
                onClick={handleClose}
            >
                <Close style={{ cursor: 'pointer' }} />
            </CloseIcon>
            <DialogTitle id="alert-dialog-title" sx={{
                '&.MuiTypography-h6': {
                    fontSize: Fonts.GeneralHeaderFont.fontSize,
                    fontWeight: Fonts.GeneralHeaderFont.fontWeight,
                    textAlign: 'center',
                    color: FontColors.Blue002E5C,
                    fontStyle: 'normal',
                    lineHeight: '32px',
                    textTransform: 'capitalize',
                },
            }}>
                {title}
            </DialogTitle>

            <Content style={contentStyle}>
                {content}
            </Content>
            <ButtonActions style={buttonStyle}>
                {children}
            </ButtonActions>
        </Dialog>
    );
}